/**
 * Screen Home
 * @description: Es la pantalla principal de la aplicación.
 * @date 14/11/2022.
 * @returns JSX del Screen.
 */

import { useCallback, useEffect, useState } from "react";
import { Button, Col, Container, Form, Row, Spinner } from "react-bootstrap";
import useFetch from "../../hooks/useFetch";
import DashCard from "../../components/Dashboard/DashCard/DashCard";
import { DashboardInterface } from "../../interfaces/DashboardInterface";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { IconProp } from '@fortawesome/fontawesome-svg-core';
import { faSearch } from "@fortawesome/free-solid-svg-icons";
import { toast } from "react-toastify";

const classes = require("./Home.module.css").default;

type DateTime = {
  desde: string | null;
  hasta: string | null;
};

const Home = () => {
  const { sendRequest } = useFetch();
  const [conteo, setConteo] = useState<DashboardInterface[]>();
  const [timestamp, setTimestamp] = useState<DateTime>({
    desde: null,
    hasta: null,
  });

  //Función que trata el detalle de prueba.
  const transformData = useCallback((variable: any) => {
    setConteo(
      variable.data.filter(
        (element: any) => element.nombre !== "Con fotos pendientes"
      )
    );
  }, []);

  //Se recibe el prueba a editar
  useEffect(() => {
    sendRequest(
      {
        url: `/dashboard`,
        method: "POST",
      },
      transformData
    );
  }, [sendRequest, transformData]);

  //Filter information
  const lookForActividades = () => {
    if (!timestamp.desde || !timestamp.hasta) {
      toast.error("Es necesario colocar ambas fechas", {
        position: "top-left",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
      });
      return;
    }
    if (timestamp.desde > timestamp.hasta) {
      toast.error("Es necesario que la primera fecha sea menor a la segunda", {
        position: "top-left",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
      });
      return;
    }
    setConteo(undefined);
    sendRequest(
      {
        url: `/dashboard`,
        method: "POST",
        body: { from: timestamp.desde, to: timestamp.hasta },
      },
      transformData
    );
  };

  //Mientras se carga el contenido se muestra un spinner
  if (!conteo) {
    return (
      <div className={classes.spinnerContainer}>
        <Spinner animation="grow" variant="info" />
      </div>
    );
  }

  return (
    <div style={{ marginTop: "70px" }}>
      <Container>
        <h2>Dashboard</h2>
        <Row className="mb-3">
          <Form.Group as={Col}>
            <Form.Label>Del:</Form.Label>
            <Form.Control
              type="date"
              min="2022-12-01"
              max="2030-12-31"
              value={timestamp.desde ? timestamp.desde : ""}
              onChange={(event) =>
                setTimestamp((prev) => {
                  return { ...prev, desde: event.target.value };
                })
              }
            />
          </Form.Group>
          <Form.Group as={Col}>
            <Form.Label>Al:</Form.Label>
            <Form.Control
              type="date"
              min="2022-12-01"
              max="2030-12-31"
              value={timestamp.hasta ? timestamp.hasta : ""}
              onChange={(event) =>
                setTimestamp((prev) => {
                  return { ...prev, hasta: event.target.value };
                })
              }
            />
          </Form.Group>
          <Form.Group as={Col}>
            <Button
              style={{
                backgroundColor: "#21618C",
                borderColor: "white",
              }}
              onClick={lookForActividades}
            >
              <FontAwesomeIcon icon={faSearch as IconProp} /> Buscar
            </Button>
          </Form.Group>
        </Row>
        <div className="d-flex justify-content-center">
          {conteo.length === 0 && (
            <p>No se ha realizado ningún servicio este mes</p>
          )}
          {conteo.map((cont) => {
            return (
              <DashCard
                key={cont.nombre}
                nombre={cont.nombre}
                total={cont.total}
              />
            );
          })}
        </div>
      </Container>
    </div>
  );
};

export default Home;
